// Copyright (c) StrangeBee 2024

import { PageTemplateInput, PageTemplateController } from 'thehive-sdk';

export interface PageTemplateEventList {
    onCreate: (pageTemplate: PageTemplateInput) => Promise<void>;
    onEdit: (pageTemplate: Partial<PageTemplateInput>, pageTemplateId: string) => Promise<void>;
    onDelete: (pageTemplateId: string) => Promise<void>;
}

interface PageTemplateEventListParams {
    locale?: (label: string) => string;
    controller: PageTemplateController;
    onSuccess?: (count?: boolean, message?: string) => void;
    onError?: (label?: string) => void;
}

export const computeEventList = ({
    controller,
    locale,
    onError,
    onSuccess,
}: PageTemplateEventListParams): PageTemplateEventList => ({
    onCreate: (pageTemplate) =>
        controller
            .create(pageTemplate)
            .then(() => onSuccess?.(true, locale?.('notification.page-template.create')))
            .catch(onError),
    onEdit: (pageTemplate, pageTemplateId) =>
        controller
            .edit(pageTemplate, pageTemplateId)
            .then((): void => onSuccess?.(true, locale?.('notification.page-template.edit')))
            .catch(onError),
    onDelete: (pageTemplateId) =>
        controller
            .delete(pageTemplateId)
            .then((): void => onSuccess?.(true, locale?.('notification.page-template.delete')))
            .catch(onError),
});
